import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { store } from './Redux/store'
import { Provider } from 'react-redux'
import { FeatureFlagsProvider } from './context/FeatureFlags'
import './helpers/localisation';

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <FeatureFlagsProvider>
        <App />
      </FeatureFlagsProvider>
    </Provider>
  </React.StrictMode>
)
